//
// --- Types ---

export type RecipientKeyTypeKey = keyof typeof RECIPIENT_KEY_TYPE;
export type RecipientKeyTypeValue = typeof RECIPIENT_KEY_TYPE[RecipientKeyTypeKey];

export type RecipientTypeKey = keyof typeof RECIPIENT_TYPE;
export type RecipientType = typeof RECIPIENT_TYPE[RecipientTypeKey];

//
// --- Constants ---

export const RECIPIENT_KEY_TYPE = {
  PERSON: 'PERSON'
} as const;

export const RECIPIENT_TYPE = {
  SUPPLIER: 'SUPPLIER'
} as const;
